import React from "react";
import { CircularProgress } from "@mui/material";

export default function PreparingTestScreen({
  title = "Preparing your test",
  subtitle = "Loading questions and preparing audio.",
  helperText = "This helps your Listening section play smoothly.",
  footerText = "Please keep this tab open. It will start shortly.",
}) {
  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f7f7fb",
      }}
    >
      <div
        style={{
          width: "min(420px, 100%)",
          borderRadius: "16px",
          background: "#fff",
          padding: "32px",
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
        }}
      >
        <CircularProgress size={34} sx={{ color: "#996cfe" }} />
        <h2
          style={{
            margin: "18px 0 8px",
            fontSize: "22px",
            lineHeight: "28px",
            fontWeight: 700,
            color: "#242423",
          }}
        >
          {title}
        </h2>
        <p
          style={{
            margin: 0,
            fontSize: "15px",
            lineHeight: "22px",
            color: "#6b7280",
          }}
        >
          {subtitle}
        </p>
        {helperText && (
          <p
            style={{
              margin: "8px 0 0",
              fontSize: "15px",
              lineHeight: "22px",
              color: "#6b7280",
            }}
          >
            {helperText}
          </p>
        )}
        {footerText && (
          <p
            style={{
              margin: "14px 0 0",
              fontSize: "13px",
              lineHeight: "20px",
              color: "#8b8b96",
            }}
          >
            {footerText}
          </p>
        )}
      </div>
    </div>
  );
}
